var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchuko(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "current",
    d: "M21.6 10.8C21.6 16.7647 16.7647 21.6 10.8 21.6C4.83532 21.6 0 16.7647 0 10.8C0 4.83532 4.83532 0 10.8 0C16.7647 0 21.6 4.83532 21.6 10.8ZM19.8 9.8H18.7V6L18.6 5.7C16.8 3.1 13.9 1.5 10.7 1.5C7.50003 1.5 4.60004 3.1 2.80004 5.7V5.8V5.9V9.8H1.60004V11.8H2.70004V15.6C2.70004 15.7 2.70004 15.8 2.80004 15.8V15.9C4.60004 18.5 7.50003 20.1 10.7 20.1C13.9 20.1 16.9 18.5 18.6 15.9V11.8H19.8V9.8ZM11.3 19.1V18H10.1V19.1C7.50003 18.9 5.20004 17.6 3.70004 15.5V6.1C5.20004 4 7.50003 2.7 10.1 2.5V3.7H11.3V2.6C13.9 2.8 16.2 4.1 17.6 6.2V15.5C16.2 17.6 13.9 18.9 11.3 19.1ZM7.10003 12.3C7.92843 12.3 8.60003 11.6284 8.60003 10.8C8.60003 9.9716 7.92843 9.3 7.10003 9.3C6.27163 9.3 5.60004 9.9716 5.60004 10.8C5.60004 11.6284 6.27163 12.3 7.10003 12.3ZM16.1 10.8C16.1 11.6284 15.4284 12.3 14.6 12.3C13.7716 12.3 13.1 11.6284 13.1 10.8C13.1 9.9716 13.7716 9.3 14.6 9.3C15.4284 9.3 16.1 9.9716 16.1 10.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchuko);
export default __webpack_public_path__ + "static/media/Schuko.491085f1770533cbe9226ab23bcb9e7e.svg";
export { ForwardRef as ReactComponent };